module.exports = __webpack_public_path__ + "img/kv-prods.d2d6fcba.png";